import { render, staticRenderFns } from "./add-item-dialog.vue?vue&type=template&id=228a8e06&"
import script from "./add-item-dialog.vue?vue&type=script&lang=js&"
export * from "./add-item-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-item-dialog.vue?vue&type=style&index=0&id=228a8e06&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228a8e06')) {
      api.createRecord('228a8e06', component.options)
    } else {
      api.reload('228a8e06', component.options)
    }
    module.hot.accept("./add-item-dialog.vue?vue&type=template&id=228a8e06&", function () {
      api.rerender('228a8e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseRequests/add-item-dialog.vue"
export default component.exports